import { LocalStorageKeys } from "@/constants/local-storage-keys";

const FLAG_VALUE = "true";

/**
 * Mark that the AI-chat welcome layout should appear on the next visit to
 * `/ai-chat`. Set by Meet NutriCoach when the user finalizes onboarding so
 * the post-onboarding welcome is reliably shown — including for users who
 * restart onboarding via Settings.
 */
export const markChatWelcomePending = (): void => {
  try {
    localStorage.setItem(LocalStorageKeys.CHAT_WELCOME_PENDING_KEY, FLAG_VALUE);
  } catch {
    // Private browsing / storage disabled — swallow so chat keeps working.
  }
};

/**
 * Clear the pending flag once the user has engaged with the welcome by
 * sending their first message. After this point the chat reverts to its
 * normal empty / message-list states on subsequent visits.
 */
export const clearChatWelcomePending = (): void => {
  try {
    localStorage.removeItem(LocalStorageKeys.CHAT_WELCOME_PENDING_KEY);
  } catch {
    // ignore
  }
};

export const isChatWelcomePending = (): boolean => {
  try {
    return localStorage.getItem(LocalStorageKeys.CHAT_WELCOME_PENDING_KEY) === FLAG_VALUE;
  } catch {
    return false;
  }
};
